import { AdminMenu } from "../components/dashboard/admin-menu";
import { CertOverview } from "../components/dashboard/cert-overview";
import { NeedsAttention } from "../components/dashboard/needs-attention";
import { RecentPdfs } from "../components/dashboard/recent-pdfs";
import { RecentRecords } from "../components/dashboard/recent-records";
import { DashboardSearch } from "../components/dashboard/search-bar";

export function DashboardPage(): React.ReactElement {
  return (
    <div className="space-y-2">
      <div className="grid gap-3 lg:grid-cols-4">
        {/* Left column — primary workflow */}
        <div className="lg:col-span-3 space-y-2">
          <DashboardSearch />
          <RecentRecords />
          <NeedsAttention />
          <AdminMenu />
        </div>

        {/* Right column — status & reference */}
        <div className="space-y-2">
          <CertOverview />
          <RecentPdfs />
        </div>
      </div>
    </div>
  );
}
